export class MandateAddress {
    city: string;
    countryCode: string;
    houseNumber: string;
    street: string;
    zip: string;

    constructor(object?: any) {
        this.city = object && object.city || null;
        this.countryCode = object && object.countryCode || null;
        this.houseNumber = object && object.houseNumber || null;
        this.street = object && object.street || null;
        this.zip = object && object.zip || null;
    }
}
export class Sepa {
    iban: string;
    firstName: string;
    lastName: string;
    mandateAddress: MandateAddress;
    gender: string; // female / male

    constructor(object?: any) {
        this.iban = object && object.iban || null;
        this.firstName = object && object.firstName || null;
        this.lastName = object && object.lastName || null;
        this.mandateAddress = object && new MandateAddress(object.mandateAddress) || new MandateAddress();
        this.gender = object && object.gender || null;
    }
    static getProductID() {
        return 771;
    }
    isEmpty(): boolean {
        return !this.iban && this.iban !== '';
    }
    getPaymentMethodName(): string {
        return 'SEPA_DIRECT';
    }

    isFullyCompleted(): boolean {
        return !!this.iban &&
            !!this.firstName &&
            !!this.lastName &&
            !!this.mandateAddress &&
            !!this.gender;
    }
}
